export default "__VITE_ASSET__CA2kd06v__"